<template>
	<page size="A4">
        <template v-for="(bill, index) in computed_room_sorted">
            <div
                :key="index"
                class="col-6"
            >
                <table class="mx-auto">
                    <tr>
                        <td
                            colspan="2"
                            class="text-left text-no-wrap font-weight-bold"
                            style="width: 200px"
                        >
                            Tháng {{ bill.month }}
                        </td>
                    </tr>
                    <tr>
                        <td
                            class="text-left text-no-wrap font-weight-bold"
                            style="width: 200px;"
                        >
                            {{ bill.name }}
                        </td>
                        <td class="text-right text-no-wrap font-weight-bold" style="width: 200px">
                            {{ bill.room_id }}
                        </td>
                    </tr>
                    <!-- <tr>
                        <td
                            class="text-left text-no-wrap font-weight-bold"
                            style="width: 200px"
                        >
                            Số người ở
                        </td>
                        <td class="text-right text-no-wrap" style="width: 200px">
                            {{ bill.customers.length }} người
                        </td>
                    </tr> -->
                    <tr>
                        <td class="font-weight-bold" colspan="2">Tiền điện</td>
                    </tr>
                    <tr>
                        <td class="text-left text-no-wrap">Đơn giá</td>
                        <td class="text-right text-no-wrap">
                            {{ bill.electric_price | formatNumber }}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-left text-no-wrap">-- Đầu tháng</td>
                        <td class="text-right text-no-wrap">
                            {{ bill.electric.start | formatNumber }}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-left text-no-wrap">-- Cuối tháng</td>
                        <td class="text-right text-no-wrap">
                            {{ bill.electric.end | formatNumber }}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-left text-no-wrap">-- Tiêu thụ</td>
                        <td class="text-right text-no-wrap">
                            {{
                                (bill.electric.end - bill.electric.start)
                                    | formatNumber
                            }}
                        </td>
                    </tr>
                    <tr class="font-weight-bold">
                        <td class="text-left text-no-wrap">Thành tiền</td>
                        <td class="text-right text-no-wrap">
                            {{ bill.electric.total_bill | formatNumber }}
                        </td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold" colspan="2">
                            Tiền nước
                        </td>
                    </tr>
                    <tr>
                        <td class="text-left text-no-wrap">Đơn giá</td>
                        <td class="text-right text-no-wrap">
                            {{ bill.water_price | formatNumber }}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-left text-no-wrap">-- Đầu tháng</td>
                        <td class="text-right text-no-wrap">
                            {{ bill.water.start | formatNumber }}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-left text-no-wrap">-- Cuối tháng</td>
                        <td class="text-right text-no-wrap">
                            {{ bill.water.end | formatNumber }}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-left text-no-wrap">-- Tiêu thụ</td>
                        <td class="text-right text-no-wrap">
                            {{ (bill.water.end - bill.water.start) | formatNumber }}
                        </td>
                    </tr>
                    <tr class="font-weight-bold">
                        <td class="text-left text-no-wrap">Thành tiền</td>
                        <td class="text-right text-no-wrap">
                            {{ bill.water.total_bill | formatNumber }}
                        </td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">
                            Tiền nhà
                        </td>
                        <td class="text-right">
                            {{ bill.room_bill | formatNumber }}
                        </td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">
                            Tiền rác và vệ sinh
                        </td>
                        <td class="text-right text-no-wrap">
                            {{ bill.trash_bill | formatNumber }}
                        </td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">
                            Tiền Internet
                        </td>
                        <td class="text-right text-no-wrap">
                            {{ bill.internet.total_bill | formatNumber }}
                        </td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">
                            Tiền xe
                        </td>
                        <td class="text-right text-no-wrap">
                            {{
                                (bill.motorbike.total_bill + bill.bike.total_bill)
                                    | formatNumber
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">Số ngày</td>
                        <td class="text-right">{{ bill.date_count | formatNumber }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">
                            Tiền máy giặt
                        </td>
                        <td class="text-right text-no-wrap">
                            {{ bill.washing_machine.total_bill | formatNumber }}
                        </td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">
                            Tiền máy lạnh
                        </td>
                        <td class="text-right text-no-wrap">
                            {{ bill.air_conditioner.total_bill | formatNumber }}
                        </td>
                    </tr>
                    <tr class="font-weight-bold">
                        <td class="text-left">TỔNG CỘNG</td>
                        <td class="text-right">
                            {{ bill.total_bill | formatNumber }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">BIDV (Nguyen Thi Gam): 31210000374258</td>
                    </tr>
                    <tr>
                        <td colspan="2">VCB (Nguyen Thi Gam): 0181003531061</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold" colspan="2">Gọi 0835990179 gặp Hương để phản ánh</td>
                    </tr>
                </table>
            </div>
            <div v-if="((index + 1) % 4) == 0" :key="index + '_break'" style="break-after: page;"></div>
        </template>
	</page>
</template>

<script>
import { deepCopy } from '../../helpers/helpers';
export default {
	name: "print-room-bill",
	props: {
		room_data: {
			type: Array,
			default: []
		}
	},
	data() {
		return {};
    },
    computed: {
        computed_room_sorted() {
			const virtual_room_data = deepCopy(this.room_data);
			const gb = virtual_room_data.filter(room => room.building === "GB");
			const tt = virtual_room_data.filter(room => room.building === "TT");
			const mt = virtual_room_data.filter(
				room => room.building === "MT"
			);
			const bn = virtual_room_data.filter(room => room.building === "BN");
			const a = virtual_room_data.filter(room => {
				const last_char = room.room_id[room.room_id.length - 1];
				return room.building != "MA" && last_char == "A";
			});
			const b = virtual_room_data.filter(room => {
				const last_char = room.room_id[room.room_id.length - 1];
				return room.building != "GB" && last_char == "B";
			});
			const ma = this.room_data.filter(room => room.building === "MA");
            // return [gb, tt, mt, bn, a, b, ma]
            return gb.concat(tt).concat(mt).concat(bn).concat(a).concat(b).concat(ma)
		}
    }
};
</script>


<style scoped>
.col-6 {
	float: left;
	width: 50%;
}
body {
	background: rgb(204, 204, 204);
}
page {
	background: white;
	display: block;
	margin: 0 auto;
	margin-bottom: 0.5cm;
	box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}
page[size="A4"] {
	width: 21cm;
	height: 29.7cm;
}
page[size="A4"][layout="landscape"] {
	width: 29.7cm;
	height: 21cm;
}
page[size="A3"] {
	width: 29.7cm;
	height: 42cm;
}
page[size="A3"][layout="landscape"] {
	width: 42cm;
	height: 29.7cm;
}
page[size="A5"] {
	width: 14.8cm;
	height: 21cm;
}
page[size="A5"][layout="landscape"] {
	width: 21cm;
	height: 14.8cm;
}
@media print {
	body,
	page {
		margin: 0;
		box-shadow: 0;
	}
}
</style>